
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as MoveIconComponent } from "./move-icon.svg";

export const MoveIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <MoveIconComponent {...props} />;
};
